import { render, staticRenderFns } from "./ConnectionGuideOld.vue?vue&type=template&id=3a80de18&scoped=true"
import script from "./ConnectionGuideOld.vue?vue&type=script&lang=js"
export * from "./ConnectionGuideOld.vue?vue&type=script&lang=js"
import style0 from "./ConnectionGuideOld.vue?vue&type=style&index=0&id=3a80de18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a80de18",
  null
  
)

export default component.exports